import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrderProvider } from '../providers/order.provider';
import { OrderClientInterface, OrderSignedInterface, SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface ContinueOrderSignUseCaseParams {
    product: SelectedProductInterface;
    client: OrderClientInterface;
}

@Injectable()
export class ContinueOrderSignUseCase
    implements UseCaseWithParam<ContinueOrderSignUseCaseParams, Observable<Transaction<OrderSignedInterface>>>
{
    constructor(private orderProvider: OrderProvider) {}

    bind(params: ContinueOrderSignUseCaseParams): Observable<Transaction<OrderSignedInterface>> {
        return this.orderProvider.continue(params.product, params.client.clientCode).pipe(
            map((transaction) =>
                transaction.map(
                    (orderSigned) => Transaction.success(cloneDeep(orderSigned)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
